<header class="pa-topbar" [class.pa-topbar--scrolled]="scrolled">
  <app-topbar-search class="pa-topbar__search"></app-topbar-search>
  <app-tool-bar class="pa-topbar__account" (logoClicked)="logoClicked.emit()"></app-tool-bar>
</header>
